// extracted by mini-css-extract-plugin
module.exports = {"desktop":"pageheader-module--desktop--21q-6","main":"pageheader-module--main--3_0rW","mobile":"pageheader-module--mobile--2ioz8"};